import { Header } from '@dreryk/react-components';

import { personnelTranslationKeys } from '../translations';

import { MyAccountNavTabs } from './MyAccountNavTabs';

type MyAccountPanelProps = {
   readonly verifyAccountConfiguration: () => Promise<void>;
};

export const MyAccountPanel = (props: MyAccountPanelProps): JSX.Element => {
   return (
      <>
         <Header testId={'myAccount'}>{personnelTranslationKeys.myAccount.header}</Header>
         <MyAccountNavTabs
            onCertificateSave={props.verifyAccountConfiguration}
            onUpdatePersonalData={props.verifyAccountConfiguration}
         />
      </>
   );
};
